export type CustomFieldTarget = 'EMPLOYEE' | 'CANDIDATE' | 'ASSET' | 'REQUEST_TYPE'
export type CustomFieldType = 'TEXT' | 'NUMBER' | 'DATE' | 'DROPDOWN' | 'FILE' | 'LOOKUP'

export const CUSTOM_FIELD_TARGETS: { value: CustomFieldTarget; label: string; note?: string }[] = [
  { value: 'EMPLOYEE', label: 'Employee' },
  { value: 'CANDIDATE', label: 'Candidate', note: 'Recruitment arrives in Phase 6' },
  { value: 'ASSET', label: 'Asset', note: 'Assets arrive in Phase 7' },
  { value: 'REQUEST_TYPE', label: 'Request type' },
]

export const CUSTOM_FIELD_TYPES: { value: CustomFieldType; label: string; hint: string }[] = [
  { value: 'TEXT', label: 'Text', hint: 'A line of text. Length and a pattern can be required.' },
  { value: 'NUMBER', label: 'Number', hint: 'Stored as a number, so ranges and sorting work.' },
  { value: 'DATE', label: 'Date', hint: 'Held as YYYY-MM-DD.' },
  { value: 'DROPDOWN', label: 'Dropdown', hint: 'A fixed list of choices; at least one is required.' },
  { value: 'FILE', label: 'File', hint: 'Holds an uploaded file.' },
  { value: 'LOOKUP', label: 'Lookup', hint: 'Points at an existing record — an employee, a department.' },
]

export interface CustomFieldOption {
  value: string
  label: string
}

export interface CustomFieldDefinitionView {
  id: string
  legalEntityId: string | null
  targetType: string
  targetId: string | null
  code: string
  label: string
  helpText: string | null
  fieldType: CustomFieldType
  required: boolean
  options: CustomFieldOption[]
  regex: string | null
  minNumber: number | null
  maxNumber: number | null
  minLength: number | null
  maxLength: number | null
  minDate: string | null
  maxDate: string | null
  lookupSource: string | null
  sortOrder: number
  active: boolean
  searchable: boolean
  exportable: boolean
}

export interface BrandingView {
  id: string | null
  legalEntityId: string | null
  legalEntityName: string | null
  logoFileId: string | null
  logoDarkFileId: string | null
  faviconFileId: string | null
  letterheadFileId: string | null
  primaryColor: string | null
  accentColor: string | null
  emailFooterHtml: string | null
  documentFooter: string | null
}

export interface GrantView {
  id: string
  userId: string
  userEmail: string
  roleId: string
  roleCode: string
  roleName: string
  legalEntityId: string | null
  legalEntityName: string | null
  divisionId: string | null
  establishmentId: string | null
  reason: string | null
  grantedAt: string
  expiresAt: string | null
  /** False once revoked or expired — the row stays for the audit trail. */
  live: boolean
}

/** A recorded exception to a segregation rule. */
export interface OverrideView {
  id: string
  userId: string
  legalEntityId: string | null
  /** The two permissions that may not normally be held together, as "a + b". */
  conflictingPair: string
  reason: string
  approvedBy: string | null
  approvedAt: string
  expiresAt: string | null
  revokedAt: string | null
  /** False once revoked or expired — the row stays either way. */
  live: boolean
}

/** One read of a sensitive field, recorded as it happened. */
export interface AccessLogView {
  id: string
  userId: string
  userEmail: string | null
  entityType: string
  entityId: string
  /** Which fields were revealed, not merely which record was opened. */
  fields: string[]
  reason: string | null
  ipAddress: string | null
  accessedAt: string
}
